import React, { useState } from 'react';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const LanguageSelector = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: 'us' },
    { code: 'pt', name: 'Português', flag: 'br' },
    { code: 'es', name: 'Español', flag: 'es' },
    { code: 'ru', name: 'Русский', flag: 'ru' },
    { code: 'zh-CN', name: '中文', flag: 'cn' }
  ];

  const getCurrentLanguage = () => {
    return languages.find(lang => lang.code === i18n.language) || languages[0];
  };

  const changeLanguage = (langCode) => {
    i18n.changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {/* Custom Language Selector */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 text-white hover:text-[#00E5A0] transition-colors duration-200 font-medium px-3 py-2 rounded-md hover:bg-[#00D4FF]/10"
      >
        <Globe size={20} />
        <img 
          src={`https://flagcdn.com/w40/${getCurrentLanguage().flag}.png`}
          alt={getCurrentLanguage().name}
          className="w-6 h-4 object-cover rounded"
        />
        <span className="hidden md:inline">{getCurrentLanguage().code.toUpperCase()}</span>
        <svg
          className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)}
          ></div>
          
          <div className="absolute right-0 mt-2 w-56 bg-[#0a1628]/98 backdrop-blur-md border border-[#00D4FF]/30 rounded-md shadow-2xl z-50 overflow-hidden">
            {languages.map((lang) => (
              <button
                key={lang.code}
                onClick={() => changeLanguage(lang.code)}
                className={`w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-[#00D4FF]/20 transition-colors ${
                  i18n.language === lang.code ? 'bg-[#00D4FF]/15 border-l-4 border-[#00E5A0]' : ''
                }`}
              >
                <img 
                  src={`https://flagcdn.com/w40/${lang.flag}.png`}
                  alt={lang.name}
                  className="w-8 h-6 object-cover rounded shadow-md"
                />
                <span className="text-white font-medium text-base">{lang.name}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default LanguageSelector;
